import React from 'react';

interface Props {
  className?: string;
}

const Mark: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5569 4.81659L20 3.37985L17.1202 0.5L15.6834 1.93675L10 7.62015L4.31659 1.93675L2.87985 0.5L0 3.37985L1.43675 4.81659L7.12015 10.5L1.4431 16.1834L0 17.6202L2.87985 20.5L4.31659 19.0633L10 13.3798L15.6834 19.0633L17.1202 20.5L20 17.6202L18.5633 16.1834L12.8798 10.5L18.5633 4.81659H18.5569Z"
      fill="currentColor"
      id="Vector"
    />
  </svg>
);

export default Mark;
